export default __webpack_public_path__ + "static/B0211-171b1ac744f78ea0adf2b06b9f255abe.png";